<template>
  <Navbar :title="'认证企业信息'"></Navbar>
  <div class="content content-bg" @click="hideSearch">
    <img class="img" src="@/assets/images/coupon/bg_popup_3@2x.png" />
    <van-form style="padding: 70px 0;">
        <div class="form">
            <div class="title">上传营业执照</div>
            <div class="sub-title">完成认证需要核实营业执照信息，请上传营业执照</div>
        
            <div class="upload-box">
                <van-uploader :after-read="afterRead">
                    <img :src="form.business_license" class="img-s" v-if="form.business_license"/>
                    <img src="../../assets/images/coupon/upload@2x.png" class="img-s" v-else/>
                </van-uploader>
            </div>
                <van-cell-group class="cell-group" inset>
                <!-- 通过 pattern 进行正则校验 -->
                <van-field v-model="form.company_name" label="企业名称" placeholder="请输入企业名称" @input="formDebounce"
                @click-input.stop="handleInput">
                </van-field>
                <div class="detail" v-if="isFocus">
                <search-detail :searchList="searchList" :isSearch="isSearch" @toMatchDetail="toMatchDetail"
                    ref="searchDetails"></search-detail>
                </div>
            </van-cell-group>
        
            <van-cell-group class="cell-group social_code" inset>
                <van-field v-model="form.social_code" label="统一社会信用代码" placeholder="请输入统一社会信用代码">
                </van-field>
            </van-cell-group>
        </div>
        <div class="form">
        <div class="title" style="margin-top:0;">个人信息填写</div>
        <van-cell-group class="cell-group" inset>
            <van-field v-model="form.user_name" label="姓  名" placeholder="请输入联系人姓名">
            </van-field>
        </van-cell-group>
        <van-cell-group class="cell-group" inset>
            <van-field v-model="form.phone" label="手机号码" name="phone" type="number" maxlength="11" placeholder="请输入手机号" >
            </van-field>
        </van-cell-group>
        <van-cell-group class="cell-group flex" inset v-if="!showCode" style="border:0;">
            <!-- 通过 validator 进行函数校验 -->
            <div class="validator-box flex-item">
            <van-field v-model="form.code" name="validator" type="number" placeholder="请输入验证码">
            </van-field>
            </div>
            <div class="code-box flex-item">
            <van-button class="btn-code" size="small" type="primary" @click="getCode" :disabled="disabled">{{ codeText }}</van-button>
            </div>
        </van-cell-group>
        <div class="cell-group-btn">
            <van-button class="btn" round block type="primary" :disabled="!form.company_name || !form.phone || !form.user_name"
            @click.stop="submit">
            提交信息
            </van-button>
        </div>
        </div>
    </van-form>
  </div>
</template>
<script>
import { queryUserById, getCode, getCompanyLists, companyEdit, upload } from '@/api/home'
import Navbar from '@/components/Navbar.vue'
import { clickUrl, clickUrlToPhone } from '@/utils'
import SearchDetail from '@/components/SearchDetail.vue'
import { baseUrl } from '@/config'

function debounce(func, wait = 1000) { //可以放入项目中的公共方法中进行调用
  let timeout;
  return function (event) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.call(this, event)
    }, wait)
  }
}

export default {
  name: 'Purchase',
  components: { Navbar, SearchDetail },
  data() {
    return {
      form: {
        company_id: '', 
        company_name: '',
        phone: '',
        code: '',
        user_name: '',
        social_code: '',
        business_license: ''
      },
      userInfo: {},
      loading: false,
      codeText: '获取验证码',
      isFocus: false,
      isSearch: false,
      searchList: [],
      pattern: /1\d{10}/,
      disabled: false
    }
  },
  computed:{
    showCode(){
      return ((this.userInfo.company && this.form.company_name == this.userInfo.company.name) &&
      (this.form.phone == this.userInfo.phone) &&
      (this.form.user_name == this.userInfo.name) 
      )
    },
    setImg() {
        let src = this.form.business_license
        if (!src || src == null || src == "") {
            return "@/assets/images/coupon/upload@2x.png"
        }
        return baseUrl  + src
    },
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    async getUserInfo() {
      try {
        let res = await queryUserById()
        this.userInfo = res.result || {}
        this.form = Object.assign({},{
            company_id: res.result.company_id ? res.result.company_id : '',
            company_name: res.result.company ? res.result.company.name : '',
            phone: res.result.phone ? res.result.phone : '',
            user_name: res.result.name ? res.result.name : '',
            business_license: res.result.company ? res.result.company.business_license : '',
            social_code: res.result.company ? res.result.company.social_code : '',
        })
      } catch { }
    },
    formDebounce: debounce(function () {
      this.search()
    }, 1000),
    handleInput() {
      this.isFocus = true
    },
    hideSearch() {
      this.isFocus = false
    },
    async search() {
      this.isSearch = true
      let res = await getCompanyLists({ keywords: this.form.company_name })
      this.searchList = res.result || []
      console.log(this.searchList.name);
      this.isSearch = false
    },
    toMatchDetail(arg) {
      console.log(this, arg)
      this.form.company_name = arg.name
      this.isFocus = false
    },
    async getCode() {
      if (this.form.phone == "") {
        this.$toast("手机号不得为空")
        return false
      }
      if (this.form.phone.length != 11 || !/1\d{10}/.test(this.form.phone)) {
            this.$toast({message: '手机号输入错误'})
            return false
      }
        if (this.disabled) {
          return false
      }
      this.disabled = true
      try {
        let res = await getCode({
          phone: this.form.phone
        })
        this.$toast.success({ message: '发送成功', duration: 2000 })
        let maxNum = 60
        let oldCodeText = this.codeText
        this.codeText = `${maxNum}s` //初始显示倒计时
        let codeCountDown = setInterval(() => {
          let countDownNum = maxNum--
          this.codeText = `${countDownNum}s`
          if (countDownNum == 0) {
            //倒计时结束
            this.codeText = '重新获取验证码'
            clearInterval(codeCountDown)
            this.disabled = false
          }
        }, 1000)
      } catch {
         this.disabled = false
      }
    },
    async submit() {
      var that = this
      if (this.loading) {
        return false
      }
      this.loading = true
      let { company_id,company_name, phone, code, user_name,social_code,business_license } = this.form

    if(!this.checkForm()){
        this.loading = false
        return false
    }

      let params = {
        id: company_id,
        company_name: company_name,
        phone: phone,
        code: code,
        user_name: user_name,
        social_code: social_code,
        business_license: business_license
      }
      try {
        let res = await companyEdit(params)
        this.orderInfo = res.result
        that.$toast.success({ message: '提交成功' })
        this.checkXcx()
      } catch {
        // that.$toast({ message: '提交失败' })
      } finally {
        this.loading = false
      }

    },
    checkForm(){
        if (this.form.business_license == null) {
            this.$toast({message: '请上传营业执照文件'});
            return false
        }

        if(!this.form.company_name){
            this.$toast({message: '请输入企业名称'})
            return false
        }

    //   var regName = /^[\u4e00-\u9fa5]{2,60}$/;
    //   if (this.form.company_name.length < 2 || !regName.test(this.form.company_name)) {
    //     this.$toast({message: '企业名称输入错误'});
    //     return false
    //   }
        if(!this.form.social_code){
            this.$toast({message: '请输入统一社会信用代码'})
            return false
        }
    //   if (this.Tyshyxdm(this.form.company_sn) == false) {
    //     this.$toast({message: '统一社会信用代码错误'});
    //     return
    //   }

        if (this.form.phone.length != 11 || !/1\d{10}/.test(this.form.phone)) {
            this.$toast({message: '手机号输入错误'});
            return false
        }

        if(!this.form.user_name){
            this.$toast({message: '请输入姓名'})
            return false
        }
    //   var reg1Name = /^[\u4e00-\u9fa5]{2,4}$/;
    //   if (this.form.user_name.length < 2 || !reg1Name.test(this.form.user_name)) {
    //     this.$toast({message: '姓名输入错误'});
    //     return false
    //   }

      if (!this.showCode && !this.form.code) {
        this.$toast({message: '请填写短信验证码'});
        return false
      }
        return true
    },
    checkXcx() {
      var u = navigator.userAgent
      if (u.indexOf('miniProgram') !== -1) {//在小程序里
        return false
      }
      if (sessionStorage.getItem('couponUrl') != null) {
        sessionStorage.removeItem('couponUrl')
        this.$router.go(-1)
       }else{
        // 在微信网页
        this.$router.replace({ path: '/coupon' })
       }
    },
    async afterRead(file) {
       var that=this
      // 此时可以自行将文件上传至服务器
      this.cutImageBase64(file.file, 1000, 0.8, async function (base64Data) {
        //下面的事项
        try{
            let res = await upload({'type':'company','file':base64Data})
            let result = res.result
            console.log(result)
          if(!res.result.Name || !res.result.RegNum){
            that.$dialog.alert({message: '您上传的营业执照无法识别，请上传清晰的图像'});
            return
          }

          that.form.business_license=res.result.url
          that.form.company_name=res.result.Name
          that.form.social_code=res.result.RegNum
        } catch{}
      });

    },
     cutImageBase64: function (file, wid, quality, callback) {
      var URL = window.URL || window.webkitURL;
      var blob = URL.createObjectURL(file);
      var base64;
      var img = new Image();
      img.src = blob;
      img.onload = function () {
        var that = this;
        //生成比例
        var w = that.width,
            h = that.height,
            scale = w / h;
        w = wid || w;
        h = w / scale;
        
        //生成canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        canvas.setAttribute("width", w)
        canvas.setAttribute("height", h)
        ctx.drawImage(that, 0, 0, w, h);
        // 生成base64
        base64 = canvas.toDataURL('image/jpeg', quality || 0.8);
        callback(base64)
      };
    },
  }
}
</script>
<style lang="scss" scoped>
.content-bg{
  img{
    height: auto;
    top: -80px;
    background-size: contain;
  }
}
.form {
  margin-bottom: 12px;
  background: #fff;
  padding: 14px 32px;
  position: relative;
  z-index: 1;
  box-shadow: 0px -2px 12px 1px rgba(0, 0, 0, 0.1);
  border-radius: 20px;

  .title {
    font-size: 16px;
    font-weight: 500;
    color: #343434;
    line-height: 16px;
    text-align: center;
    margin: 15px auto 10px;
  }
  .sub-title{
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0,.4);
        text-align: center;
  }
}

.cell-group {
  margin: 7px 0;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #D8DEE4;

  .van-cell {
    background: #fff;
  }
}

.cell-group-btn {
  margin: 35px 0 14px;
  font-size: 14px;

  .btn {
    width: 80%;
    height: 44px !important;
    margin: 0 auto;
  }
}
::v-deep .validator-box{
  background: #E2F5F2;
  border-radius: 8px;
  opacity: 1;
  text-align: center;
  box-sizing: border-box;
  .van-field{
    padding: 0;
    input.van-field__control{
      background: #E2F5F2;
        line-height:40px;
        text-align: center;
        border-radius: 8px;
        border: 1px solid #24CAA4;
        box-sizing: border-box;
        height: 38px;
    }
  }
}
.code-box{
    width: 101px;
    height: 40px;
    margin-left: 7px;
    .btn-code{
      width: 100%;
      height: 100% !important;
      background: #24CAA4;
      border-radius: 8px;
      color: #fff;
      border: 1px solid #24CAA4;
    }
  }

.upload-box{
    width: 166px;
    height: 106px;
    margin: 20px auto;
    text-align: center;
    padding: 20px 15px;
    background: linear-gradient(#2FB3FB, #2FB3FB) left top,
    linear-gradient(#2FB3FB, #2FB3FB) left top,
    linear-gradient(#2FB3FB, #2FB3FB) right top,
    linear-gradient(#2FB3FB, #2FB3FB) right top,
    linear-gradient(#2FB3FB, #2FB3FB) right bottom,
    linear-gradient(#2FB3FB, #2FB3FB) right bottom,
    linear-gradient(#2FB3FB, #2FB3FB) left bottom,
    linear-gradient(#2FB3FB, #2FB3FB) left bottom;
 background-repeat: no-repeat;
  background-size: 2px 20px, 20px 2px;

    .img-s{
        width: 166px;
        height: 106px;
        background-size: 100% 100%;
    }
}

::v-deep .van-field__label{
  width: 1.8rem;
  color: #666;
  border-right: 1px solid #D8DEE4;
  font-size: 12px;
}
::v-deep .social_code{
    .van-field__label{
        width: 2.8rem; 
        font-size: 12px;
    }
}
</style>
